import Vuex from 'vuex'

import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
      state: {
            render: 0,
            info: [],
            infoSoc:[],
      },
      mutations: {
            rendering (state) {
                  state.render += 1
            },
            updateInfo(state, info) {
                  state.info = info
            },
            updateInfoSoc(state, info) {
                  state.infoSoc = info
            },
      }
})